var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.funcionFiltrar }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.lstProveedores,
                    "exported-file-name": "ProveedoresDeGPS"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridTodos", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad,
              "row-data": _vm.lstProveedores
            },
            on: {
              gridOptionsEnriched: function($event) {
                _vm.enrichedGridOptions = $event
              }
            }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarAsociacionesEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.mensajeAsociacionEliminar,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleCierreEliminar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarRecepcionesEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.mensajeRecepcionesEliminar,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleCierreEliminar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "el Proveedor de GPS"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c("CrearProveedorModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: { cerrar: _vm.handleCierreModalCrear }
      }),
      _c("VerProveedorModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          proveedorSeleccionado: _vm.proveedorSeleccionado
        },
        on: { cerrar: _vm.handleCierreModalVer }
      }),
      _c("EditarProveedorModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          proveedorSeleccionado: _vm.proveedorSeleccionado
        },
        on: { cerrar: _vm.handleCierreModalEditar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }